import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getMostUsedSubscription } from '../../../feature/dashboard/DashboardSlice'

const planColors = ['#6366f1', '#22c55e', '#8b5cf6', '#f59e0b', '#3b82f6', '#ec4899']

function SubscriptionPlans({ month, year }) {
    const dispatch = useDispatch()
    const { mostUsedSubscription } = useSelector((state) => state.dashboards)

    useEffect(() => { dispatch(getMostUsedSubscription({ month, year })) }, [month, year])

    const plans = Array.isArray(mostUsedSubscription) ? mostUsedSubscription : []
    const maxCount = Math.max(...plans.map(p => p.activeSubscriptions || 0), 1)

    return (
        <div style={ {minHeight: "280px",maxHeight:"320px", overflowY: "auto", background: '#fff', borderRadius: 12, padding: '20px 24px', border: '1px solid #f0f0f0', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <div>
                    <div style={{ fontSize: 17, fontWeight: 700, color: '#111' }}>Most Used Subscription Plans</div>
                    <div style={{ fontSize: 12, color: '#aaa', marginTop: 2 }}>Active subscriptions by plan · this period</div>
                </div>
                <span style={{ fontSize: 13, color: '#6366f1', cursor: 'pointer', fontWeight: 500 }}>Manage plans</span>
            </div>
            {plans.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '32px 0', color: '#bbb' }}>
                    <div style={{ fontSize: 32, marginBottom: 8 }}>📋</div>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>No subscription data for this period</div>
                </div>
            ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12 }}>
                    {plans.map((p, i) => {
                        const count = p.activeSubscriptions || 0
                        const progress = Math.round((count / maxCount) * 100)
                        const color = planColors[i % planColors.length]
                        const name = p.name || p.planName || `Plan ${i + 1}`
                        const price = p.price ? `$${p.price}` : ''
                        return (
                            <div key={i} style={{ border: '1px solid #f0f0f0', borderRadius: 10, padding: '14px 16px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                    <span style={{ fontWeight: 700, fontSize: 14, color: '#111' }}>{name}</span>
                                    {i === 0 && <span style={{ background: '#eef2ff', color: '#6366f1', borderRadius: 20, padding: '2px 8px', fontSize: 11, fontWeight: 600 }}>Most used</span>}
                                </div>
                                <div style={{ fontSize: 28, fontWeight: 800, color: '#111', marginBottom: 2 }}>{count}</div>
                                <div style={{ fontSize: 12, color: '#aaa', marginBottom: 10 }}>active subscriptions</div>
                                <div style={{ height: 4, borderRadius: 4, background: '#f0f0f0', overflow: 'hidden', marginBottom: 8 }}>
                                    <div style={{ width: `${progress}%`, height: '100%', background: color, borderRadius: 4 }} />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#888' }}>
                                    <span style={{ fontWeight: 600, color: '#555' }}>{price}{p.billingCycle ? `/${p.billingCycle}` : ''}</span>
                                    <span>{p.sharePercentage ?? progress}% share</span>
                                </div>
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

export default SubscriptionPlans
